module.exports = __webpack_public_path__ + "static/media/udemy.a82afc6d.png";